const ACTIONS = Object.freeze({
  OPEN_SCHEDULE_MODAL: 'SCHEDULE',
  GO_TO_PAGE: 'STAMP',
  BACK_TO_LDP: 'BACK',
})

export default ACTIONS
